import { useState } from "react";
import type { CheckResponse } from "../types/api";

const reasons = [
  { value: "too_harsh", label: "too harsh" },
  { value: "not_funny", label: "not funny" },
  { value: "missed_context", label: "missed the context" },
  { value: "rewrite_changed_meaning", label: "rewrite changed my meaning" },
  { value: "other", label: "other" }
] as const;

type FeedbackProps = {
  response: CheckResponse;
};

export function Feedback({ response }: FeedbackProps) {
  const [state, setState] = useState<"idle" | "needs_reason" | "sent_helpful" | "sent_needs_work">("idle");

  async function send(helpful: boolean, reason: string) {
    const payload = {
      request_id: response.request_id,
      helpful,
      reason,
      mode: response.result.detected_mode,
      verdict: response.result.verdict.key,
      prompt_version: response.prompt_version
    };
    await fetch("/api/feedback", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(() => undefined);
    setState(helpful ? "sent_helpful" : "sent_needs_work");
  }

  if (state === "sent_helpful") return <p className="feedback-confirm">The vibe department appreciates your service. ✨</p>;
  if (state === "sent_needs_work") return <p className="feedback-confirm">Fair. The clipboard has been notified.</p>;

  return (
    <div className="feedback">
      <p>Did the vibe department cook?</p>
      {state === "idle" ? (
        <div className="inline-actions">
          <button type="button" className="chip-button" onClick={() => send(true, "none")}>
            yes ✨
          </button>
          <button type="button" className="chip-button" onClick={() => setState("needs_reason")}>
            needs work
          </button>
        </div>
      ) : (
        <div className="chip-row">
          {reasons.map((reason) => (
            <button key={reason.value} type="button" className="chip-button" onClick={() => send(false, reason.value)}>
              {reason.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
